<style lang="scss" scoped>
.vslist-detail {
  min-height: 20px;
  padding: 16px;
  margin-bottom: 20px;
  background-color: #f3f7f9;
  border: 1px solid #e4eaec;
  border-radius: 3px;
  width: 80%;
}
</style>

<template> 
    <div class="lookitem" style="max-height:500px;overflow:auto;">
        <Row class="bg-fff shadow padding-bottom-20">
            <Col span='12'>
                <span class="item-label">{{$t('global.common.name',{defaultValue:'名称'})}}：</span>
                <span class="item-content">{{formData.name}}</span>
            </Col>
            <Col span='12'>
                <span class="item-label">{{$t('global.common.project',{defaultValue:'项目'})}}：</span>
                <span class="item-content">{{formData.lineId|transferText('name',products)}}</span>
            </Col>
            <Col span='12'>
                <span class="item-label">ERPSKU：</span>
                <span class="item-content">{{formData.erpSku}}</span>
            </Col>
            <Col span='24' v-for="(item,index) in svRules" :key="index">
                <header class="item-label">{{item.stockGroupName}}</header>
                <section class="item-content vslist-detail">
                    <div class="clearfix" v-for="(data,index) in item.stockVirtualGroupRuleItemEntity" :key="index">
                        <span class="width-80per pull-left">{{data.warehouseTitle}}({{data.warehouseCode}})</span>
                        <span class="pull-left">{{data.assignPercent}}%</span>
                    </div>
                    <div class="clearfix">
                        <span class="item-label">{{$t('erp.virtualstore.setusestores',{defaultValue:'设定可用店铺'})}}:</span>
                        <div style="margin-left:100px;">
                            <div v-for="(data,index) in item.stockVirtualGroupRuleAccountEntity" :key="index">{{data.accountName}}({{data.accountFlag}})</div>
                        </div>
                    </div>
                </section>
            </Col>
            <Col span='24'>
                <span class="item-label">{{$t('fbb.costmanage.explain',{defaultValue:'说明'})}}</span>
                <span class="item-content width-80per">
                    {{formData.description}}
                </span>
            </Col>
            <Col span='24'>
                <span class="item-label"></span>
                <span class="item-content width-80per">
                    <Table 
                        :columns="columns" 
                        :data="formList"
                        size="small" 
                        ref="table" 
                        :loading="tableloading"
                        border 
                        stripe>
                    </Table>
                    <compSpage
                    class="text-right margin-top-10"
                    v-bind="{total,pageSize:LogformData.rows,current:LogformData.page}" 
                    @on-update="getLogdetail"></compSpage>
                </span>
            </Col>
        </Row>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import {
    HttpVsDetail, HttpUpdateVs, HttpSaveVs, HttpSysOpLog
} from '@/service/boss/allot';
import compSpage from '@/components/boss/spage';
export default {
    components: {
        compSpage,
	},
    props: ['id'],
    data() {
        return {
            loading: false,
            tableloading:false,
            formData: {
                name: '',
                lineId: '',
                erpSku: '',
                description: '',
            },
            svRules: [],
            LogformData: {
				page: 1,
				rows: 10,
				sidx: 'id',
                sord: 'desc',
                "search[EQ_opModel]":'StockVirtualGroup',
                "search[EQ_opDataId]":this.id,
            },
            formList:[],
            total:0,
        }
    },
    created() {
        this.getDetail();
    },
    filters: {
        transferText(val, textKey, list = [], key = "id") {
            let text = "";
            list.forEach(item => {
                if (item[key] === val) {
                    text = item[textKey]
                }
            });
            return text;
        }
    },
    computed: {
        ...mapState('boss',['products']),
        columns() {
            return [{
                title: this.$t('fbb.alloment.date',{defaultValue:'日期'}),
                key: 'updatedAt',
                render(h, { row }) {
                    return <div>
                    {row.updatedAt}
                    </div>
                }
            },
            {
                title: this.$t('global.log.operator',{defaultValue:'操作人'}),
                key: 'updatedName',
                render(h, { row }) {
                    return <div>{row.updatedName}</div>
                }
            }, {
                title: this.$t('erp.distribution.operation',{defaultValue:'操作记录'}),
                key: 'opAction',
                render(h, { row }) {
                    return <div>{row.opAction}</div>
                }
            }, {
                title: this.$t('global.log.operalog',{defaultValue:'操作日志'}),
                key: 'opRemark',
                render(h, { row }) {
                    return <div>
                    {row.opRemark}
                    </div>
                }
            }, ]
        },
    },
    
    methods: {
        
        cancel() {
            this.$emit('on-close');
        },
        handleResponse(data = {}) {
            let { name, lineId, erpSku, description } = data;
            this.formData = { name, lineId, erpSku, description };
            this.svRules = data.stockVirtualGroupRules || [];
            // console.log(this.svRules)
        },
        async getDetail() {
            this.loading = true;
            HttpVsDetail({
                id: this.id
            }).then(res => {
                this.handleResponse(res.data);
                this.loading = false;
            }, err => {
                this.errorMessage(err.message);
                this.loading = false;
            })
            this.getLogdetail()
        },
        getLogdetail(data = {}){
            this.tableloading = true
            this.LogformData = Object.assign({}, this.LogformData, data);
            HttpSysOpLog(this.LogformData).then(res=>{
                this.formList = res.data.content
                this.total = res.data.totalElements || 0;
                this.tableloading = false
            },err=>{
                this.errorMessage(err.message);
            })
        }
    }
}
</script>

